import React from 'react';
import { motion } from 'framer-motion';
import Button from '../../components/Button';

const ExpandButton = ({ isExpanded, onClick }) => {
  return (
    <Button onClick={onClick} className="flex items-center gap-1 !min-w-[70px]" size="sm">
      <span className="text-sm">{isExpanded ? 'Hide' : 'Show'}</span>
      <motion.svg
        width="10"
        height="6"
        viewBox="0 0 10 6"
        fill="currentColor"
        className="ml-2"
        animate={{ rotate: isExpanded ? 180 : 0 }}
        transition={{ duration: 0.2, ease: 'easeInOut' }}
      >
        <path d="M0 0L5 5L10 0H0Z" stroke="currentColor" />
      </motion.svg>
    </Button>
  );
};

export default ExpandButton;
